export default "<div class=\"w3-block weekRecordElement\" style=\"--wriBG: {2};--wriTXT: {3}\" title=\"{4}\">\n    {0}{1}\n</div>\n    \n"